export const GT_NON_STOP_FLIGHT: string = 'STOPS-IN-0,STOPS-OUT-0';



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/types/non-stop-flight-type.ts